export enum FontWeightType {
	Light = "Light",
	Regular = "Regular",
	Medium = "Medium",
	Bold = "Bold",
}

export default FontWeightType;
